import { IAppState } from '../../redux';

export function selectHighDemandCoefficient(state: IAppState): number | null {
  const { highDemandCoefficient } = state.publishTerms;

  return highDemandCoefficient;
}
